module.exports = __webpack_public_path__ + "static/media/Screenshot_4.eb6e04ce.png";